<!-- FIN Header -->
      <!--Page connexion-->
<!-- breadcrumb -->
<div class="connexionPage marginMobile bgLogin">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-10 col-md-6 col-lg-5 breadcrumb py-3 m-0">
      Accueil&nbsp;>&nbsp;Connexion
      </div>
    </div>
  </div>
  <!-- Fin breadcrumb -->
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-10 col-md-6 col-lg-5 boxLogin p-4 mb-5 rounded">
        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-12 titreRubrique text-center">
                        Connexion
                        <div class="separTitres"></div>
                    </div>
                </div>
            </div>
            <!--Contenu connexion-->
            <div class="container p-0">
                <div class="row">
                    <div class="col-md-12">
                      <div class="alert alert-danger" role="alert" *ngIf="msgLogin!=''">
                        {{msgLogin}}
                      </div>
                      <div class="alert alert-success" role="alert" *ngIf="successLogin!=''">
                        {{successLogin}}
                      </div>
                            <div class="mb-3">
                            <label for="exampleInputEmail1" class="form-label d-block">Type du compte</label>
                              <!-- <select class="form-select" [(ngModel)]="typeCompte">
                                <option value=""></option>
                                <option value="Entreprise">Entreprise</option>
                                <option value="Particulier">Particulier</option>
                              </select> -->
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" [(ngModel)]="typeCompte" id="Entreprise" value="Entreprise">
                                <label class="form-check-label" for="Entreprise">Entreprise</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" [(ngModel)]="typeCompte" id="Particulier" value="Particulier">
                                <label class="form-check-label" for="Particulier">Particulier</label>
                              </div>
                            </div>
                            <div class="mb-3">
                            <label for="exampleInputEmail1" class="form-label" *ngIf="typeCompte=='Entreprise'">R.C</label>
                            <label for="exampleInputEmail1" class="form-label" *ngIf="typeCompte=='Particulier'">E-mail</label>
                            <input type="email" [(ngModel)]="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp">
                            </div>
                            <div class="mb-3">
                            <label for="exampleInputPassword1" class="form-label">Mot de passe</label>
                            <input type="password" [(ngModel)]="password" class="form-control" (keydown)="loginSend($event)" id="exampleInputPassword1">
                            </div>

                            <div class="oublieMdp"><p>Mot de passe oublié</p></div>
                    </div>
                    <div class="col-12 text-center">
                      <div class="btnSubmit text-center text-center" ><button (click)="login()" [disabled]="typeCompte == ''" class="btn btn-primary">Envoyer</button></div>
                      <div class="btnInscription showsub"><p>Vous n'êtes pas encore inscrit</p></div>
                    </div>
                    <div class="col-lg-3 col-md-2"></div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Fin Page connexion-->
<!--Page inscription-->
<!-- breadcrumb -->
<div class="subscribePage marginMobile bgLogin">
  <!-- Fin breadcrumb -->
  <div class="container-fluid bgLogin">
  <!--Contenu inscription-->
  <div class="container">
      <div class="row justify-content-center">

        <div class="col-10 col-md-8 col-lg-6 breadcrumb py-3 m-0">
        <a href="#">Accueil</a>&nbsp;>&nbsp;<a href="#">Inscription</a>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-10 col-md-8 col-lg-6 boxLogin p-3 mb-5 rounded">
          <div class="col-sm-12 titreRubrique text-center">
              Inscription
              <div class="separTitres"></div>
          </div>
            <div class="alert alert-danger" role="alert" *ngIf="msg!=''">
              {{msg}}
            </div>
            <div class="alert alert-success" role="alert" *ngIf="success!=''">
              {{success}}
            </div>
            <form>
                <div class="mb-3">
                    <label for="exampleInputNom" class="form-label">Nom</label>
                    <input type="text" class="form-control" name="firstname" [(ngModel)]="firstname" id="exampleInputNom">
                </div>
                <div class="mb-3">
                    <label for="exampleInputPrenom" class="form-label">Prénom</label>
                    <input type="text" class="form-control" name="lastname" [(ngModel)]="lastname" id="exampleInputPrenom">
                </div>
                <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">E-mail</label>
                <input type="email" class="form-control" name="email" [(ngModel)]="emailUser" (blur)="checkEmail()" [class.is-invalid] = "errorEmail" id="exampleInputEmail1" aria-describedby="emailHelp">
                <div class="invalid-feedback">
                  Format d'adresse email invalide
                </div>
              </div>
                <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">Mot de passe</label>
                <input type="password" class="form-control" name="pwd" [(ngModel)]="pwd" id="exampleInputPassword1">
                </div>
                <div class="mb-3">
                    <label for="exampleInputPassword1" class="form-label">Entrer votre mot de passe</label>
                    <input type="password" class="form-control" name="pwd1" [(ngModel)]="pwd1" id="exampleInputPassword1">
                </div>
                <div class="text-center">
                  <div class="btnSubmit" (click)="addUser()"><button type="submit" class="btn btn-primary">Envoyer</button></div>
                  <div class="btnalreadysub"><p>Vous êtes dèja inscrit</p></div>
                </div>
            </form>
        </div>
      </div>
  </div>
  </div>
</div>
<!--Fin Page inscription-->
 <!--Page Mot de passe oublié-->
<!-- breadcrumb -->
<div class="MDPPage">
  <div class="container">
      <div class="col-sm-12 breadcrumb py-3 m-0">
      <a href="#">Accueil</a>&nbsp;>&nbsp;<a href="#">Mot de passe</a>
      </div>
  </div>
  <!-- Fin breadcrumb -->
<div class="container-fluid bgcontact">
      <div class="row">
          <div class="col-sm-12">
              <div class="col-sm-12 titreRubrique text-center">
                  Mot de passe oublié
                  <div class="separTitres"></div>
              </div>
          </div>
</div>
  <!--Contenu MDP oublié-->
<div class="container">
      <div class="row">
          <div class="col-lg-3 col-md-2"></div>
          <div class="col-lg-6 col-md-8">
              <div class="alert alert-success" *ngIf="successChange" role="alert">
                  Un email déja envoyer pour la rénitialisation de votre mot de passe
              </div>
              <div class="alert alert-danger" role="alert" *ngIf="msgLoginChange!=''">
                {{msgLoginChange}}
              </div>
              <div class="alert alert-danger" *ngIf="errorRequis" role="alert">
                  Tous les champs sont requis!
              </div>
              <form class="pageCnx">
                <div class="mb-3">
                  <label for="exampleInputEmail1" class="form-label d-block">Type du compte</label>
                    <!-- <select class="form-select" [(ngModel)]="typeCompte">
                      <option value=""></option>
                      <option value="Entreprise">Entreprise</option>
                      <option value="Particulier">Particulier</option>
                    </select> -->
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" [(ngModel)]="typeCompteChange" name="typeCompteChange" id="EntrepriseChange" value="Entreprise">
                      <label class="form-check-label" for="EntrepriseChange">Entreprise</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" [(ngModel)]="typeCompteChange" name="typeCompteChange" id="ParticulierChange" value="Particulier">
                      <label class="form-check-label" for="ParticulierChange">Particulier</label>
                    </div>
                  </div>
                  <div class="mb-3">
                  <label for="exampleInputEmail1" class="form-label">Nom d'utilisateur</label>
                  <input type="email" class="form-control" id="exampleInputEmail1" name="username" [(ngModel)]="changePassword.username" aria-describedby="emailHelp">
                  </div>
                  <div class="mb-3">
                  <label for="exampleInputEmail1" class="form-label">E-mail</label>
                  <input type="email" class="form-control" id="exampleInputEmail1" name="email" [(ngModel)]="emailUser" (blur)="checkEmail()" [class.is-invalid] = "errorEmail" aria-describedby="emailHelp">
                  <div class="invalid-feedback">
                    Format d'adresse email invalide
                  </div>
                  </div>
                  <div class="btnSubmit"><button type="button" (click)="changePasswordAction()" class="btn btn-primary">Envoyer</button></div>
                  <div class="btnalreadysub"><p>Vous êtes dèja inscrit</p></div>
              </form>
          </div>
          <div class="col-lg-3 col-md-2"></div>
      </div>
  </div>
  </div>
</div>
